import { HugeiconsIcon, type IconSvgElement } from "@hugeicons/react";
import { cn } from "@/lib/utils";

export type { IconSvgElement };

/** Every icon in the app is a hugeicon, drawn at the same weight. */
export function Icon({
  icon,
  className,
  strokeWidth = 1.8,
}: {
  icon: IconSvgElement;
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <HugeiconsIcon
      icon={icon}
      strokeWidth={strokeWidth}
      className={cn("size-4 shrink-0", className)}
      aria-hidden
    />
  );
}
